import {LiveDashboard} from "@common/ui-components/live/live-dashboard/live-dashboard";
import collection from "./axis-chart-collection.json";
import data from "./axis-chart-data.json";

export const AxisChartThemeAuto = (props) => {
    return LiveDashboard({
        collection,
        defaultData: data,
        disabledTileActions: true,
        ...props,
    });
};
